/** Fallback when API is unavailable; keep in sync with backend default list. */
export const DEFAULT_PAYMENT_TERMS = [
  'Payable On Receipt',
  'Pay before ship',
  'Net 15',
  'Net 30',
  'Net 45',
  'Net 60'
];
